import React from 'react';
import './styles.scss';
import { ImageCol } from '@/components/ImageCol';
import {
    ImageContentCol,
    IMAGE_CONTENT_COL_SPACING
} from '@/components/ImageContentCol';
import { useTranslationHook } from '@/hooks/useTranslationHook';
import RenderDotPoints from '@/components/RenderDotPoints';

const Events = () => {
    const { translate } = useTranslationHook();

    return (
        <div className='mt-4' id='top'>
            <ImageContentCol reverse
                             title={translate('coreStaffEventsSectionTitle')}
                             spacing={IMAGE_CONTENT_COL_SPACING.BOTTOM}
                             leftContent={
                                 <>
                                     <h4>{translate('coreStaffEventsTitle')}</h4>
                                     <RenderDotPoints translateLabel='coreStaffEventsParagraphs'/>
                                 </>
                             }
                             rightContent={
                                 <div className='job-seeker-image'>
                                     <ImageCol src={'core-staff-events.png'}
                                               alt={'standing-workers'}/>
                                 </div>
                             }
            />

        </div>
    );
};

export default Events;